import React from 'react';
import PropTypes from 'prop-types';

import { InputWrapper, InputLabel, InputError } from 'components/atoms/styleds';
import Arrow from 'assets/images/backWhite.svg';
import DeletableItem from 'components/atoms/DeletableItem';

import {
  SelectDropdown,
  StyledSelectIcon,
  StyledSelectV2,
  StyledOptionV2,
} from './styled';

const LOAD_MORE_VALUE = '__load_more__';

const Select = ({
  name,
  items,
  label,
  onChange,
  selectedKey,
  error,
  defaultLabel,
  fullWidth,
  mb,
  desktopMb,
  desktopMt,
  standardWidth = false,
  defaultValue,
  itemLabelKey = 'title',
  disabled,
  isArray,
  style,
  selectHeight = 44,
  fontSize = 16,
  hasNextPage = false,
  onLoadMore,
  isLoadingMore = false,
  loadMoreLabel = 'Carica altre...',
}) => {
  const handleChange = (event) => {
    if (event.target.value === LOAD_MORE_VALUE) {
      onLoadMore?.();
      return;
    }

    onChange(event);
  };

  return (
    <InputWrapper
      height={selectHeight}
      fullWidth={fullWidth}
      mb={mb}
      desktopMt={desktopMt}
      desktopMb={desktopMb}
      standardWidth={standardWidth}
      style={style}
    >
      <InputLabel failed={!!error}>{label}</InputLabel>
      <StyledSelectV2
        failed={!!error}
        name={name}
        onChange={handleChange}
        value={selectedKey || ''}
        disabled={disabled}
        selectHeight={selectHeight}
        fontSize={fontSize}
        // defaultValue='DEFAULT'
      >
        {defaultLabel && (
          <StyledOptionV2 value={''} disabled='disabled'>
            {defaultLabel}
          </StyledOptionV2>
        )}

        {items?.map((i, index) => (
          <StyledOptionV2
            key={i.id || index.toString()}
            value={isArray ? i : i.id}
          >
            {!isArray && (i.title || i[itemLabelKey])}
            {isArray && i}
          </StyledOptionV2>
        ))}
        {hasNextPage && (
          <StyledOptionV2 value={LOAD_MORE_VALUE} disabled={isLoadingMore}>
            {isLoadingMore ? 'Caricamento...' : loadMoreLabel}
          </StyledOptionV2>
        )}
      </StyledSelectV2>
      <SelectDropdown>
        <StyledSelectIcon src={Arrow} />
      </SelectDropdown>
      {!!error && <InputError>{error}</InputError>}
    </InputWrapper>
  );
};

Select.propTypes = {
  name: PropTypes.string,
  items: PropTypes.array,
  label: PropTypes.string,
  selectedKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  showDefaultLabel: PropTypes.string,
  defaultValue: PropTypes.string,
  fullWidth: PropTypes.bool,
  standardWidth: PropTypes.bool,
  mb: PropTypes.number,
  desktopMb: PropTypes.number,
};

export default Select;
